import { render, staticRenderFns } from "./MewTable.vue?vue&type=template&id=21f22372"
import script from "./MewTable.vue?vue&type=script&lang=js"
export * from "./MewTable.vue?vue&type=script&lang=js"
import style0 from "./MewTable.vue?vue&type=style&index=0&id=21f22372&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports